// ContactUs.js
import React, { useEffect, useState } from "react";
import styles from "./ContactUs.module.css";
import ButtonComponent from "../components/CssComponents/ButtonComponent/ButtonComponent";
import SignHeader from "../components/FlowComponents/SignHeader/SignHeader";
import SignFooter from "../components/FlowComponents/SignFooter/SignFooter";
import { db } from "../firebase-config";
import { doc, getDoc } from "firebase/firestore";

const ContactUs = () => {
    const [mapLink, setMapLink] = useState("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3681.933989983619!2d88.38199947512504!3d22.656249629899687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89d4e876c3d37%3A0x58211349336f180a!2sAffiliate%20Ritual!5e0!3m2!1sen!2sin!4v1738605663824!5m2!1sen!2sin");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMapLink = async () => {
            try {
                const docRef = doc(db, 'siteContent', 'contactus');
                const docSnap = await getDoc(docRef);
                if (docSnap.exists() && docSnap.data().mapLink) {
                    setMapLink(docSnap.data().mapLink);
                }
            } catch (error) {
                console.error('Error fetching map link:', error);
                // Keep the default map link if there's an error
            } finally {
                setLoading(false);
            }
        };

        fetchMapLink();
    }, []);

    return (
        <>
            <div className={styles.page}>
                <div className={styles.contactUsContainer}>
                    <div className={styles.contactFormSection}>
                        <h2 className={styles.heading}>Contact Us</h2>

                        <form
                            onSubmit={() => { }}
                            className={styles.formContainer}>
                            <div className={styles.labelInputWrapper}>
                                <label htmlFor="name" className={styles.labelText}>Name</label>
                                <input type="text" id="name" placeholder="Your Name" className={styles.input} />
                            </div>

                            <div className={styles.labelInputWrapper}>
                                <label htmlFor="email" className={styles.labelText}>Email</label>
                                <input type="email" id="email" placeholder="Your Email" className={styles.input} />
                            </div>

                            <div className={styles.labelInputWrapper}>
                                <label htmlFor="message" className={styles.labelText}>Message</label>
                                <textarea
                                    id="message"
                                    placeholder="Your Message"
                                    rows="5"
                                    className={styles.inputTextArea}
                                ></textarea>
                            </div>

                            <ButtonComponent
                                onClick={() => { }}
                                buttonText={"Send Message"}
                                buttonType="submit"
                            />
                        </form>
                    </div>

                    <div className={styles.mapSection}>
                        {!loading && (
                            <iframe
                                title="Our Location"
                                className={styles.map}
                                src={mapLink}
                                allowFullScreen=""
                                loading="lazy"
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUs;